// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"ToggleRefinement_checkbox__272Ek"};